module.exports = __webpack_public_path__ + "img/close.53f9974e.svg";